module.exports = __webpack_public_path__ + "media/images/icons/house-850547ec4e4f996ae9c12ad1e84e98c4.svg";